import React from 'react';
import JSONSchemaForm from '@rjsf/bootstrap-4';
import Widgets from '../CustomSchemaWidgets';

interface TabFormProps {
    schema: any;
    uiSchema?: any;
    formData: any;
    rootFormData: any;
    onChange: (data: any) => void;
    onSubmit: (data: any) => void;
    onError: (error: any) => void;
    saveButtonText: string;
}

const TabForm: React.FC<TabFormProps> = ({
    schema,
    uiSchema,
    formData,
    rootFormData,
    onChange,
    onSubmit,
    onError,
    saveButtonText,
}) => {
    return (
        <div className="tab-form-container">
            <JSONSchemaForm
                schema={schema}
                uiSchema={uiSchema}
                widgets={Widgets}
                formData={formData}
                formContext={{
                    rootFormData: rootFormData,
                }}
                onChange={onChange}
                onSubmit={onSubmit}
                onError={onError}
            >
                <div className="tab-form-actions">
                    <button type="submit" className="btn btn-primary save-tab-button">
                        {saveButtonText}
                    </button>
                </div>
            </JSONSchemaForm>
        </div>
    );
};

export default TabForm;
